import { useRouter } from 'next/router';

/**
 * Retrieves the pathname as it would appear in
 * the browser's address bar, rather than the
 * Next.js pathname, which may have been rewritten.
 *
 * e.g. /artists/1 rather than /artists/page/[number]
 *
 * @returns {string} the pathname
 */
export const usePathname = (): string => {
  const router = useRouter();
  const [pathname] = router.asPath.split('?');

  return pathname;
};
